<template>
  <div>
    <app-autocomplete-client @coordonneesChange="setPlace" @codeChange="setCode"
    @afficherSlider="setSlider" :btnAdd="true" @sendPoints="setPoints"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import autocompleteClient from '@/components/filtres/autocompleteClient';
import * as types from '@/store/creationOpportunite/venteFacesLc-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';

const Panier = createNamespacedHelpers('panier');
const VenteFacesLc = createNamespacedHelpers('venteFacesLc');

export default {
  name: 'autocomplete',
  components: {
    appAutocompleteClient: autocompleteClient,
  },
  data() {
    return {
      valid: false,
      codeFace: '',
    };
  },
  computed: {
    ...Panier.mapGetters({
      panneauxLcPanier: 'panneauxLcPanier',
    }),
    ...VenteFacesLc.mapGetters({
      getAddress: 'address',
    }),
    address: {
      get() {
        return this.getAddress;
      },
      set(value) {
        this.setFilterAddress(value);
      },
    },
  },
  methods: {
    ...VenteFacesLc.mapMutations({
      setFilterAddress: types.SET_FILTER_ADDRESS,
      setAffichageCercle: types.SET_AFFICHAGE_CERCLE,
      setZoomCarto: types.SET_ZOOM_CARTO,
      setPointsAddress: types.SET_POINTS_ADDRESS,
    }),
    ...VenteFacesLc.mapActions({
      actionsGestionPanneauxLc: 'gestionPanneauxLC',
    }),
    setPlace(place) {
      this.codeFace = '';
      this.address = place;
      this.valid = place !== null;
      this.setAffichageCercle(false);
      this.recherchePanneauxLc();
    },
    setPoints(points) {
      this.setPointsAddress(points);
      this.recherchePanneauxLc();
    },
    setCode(code) {
      this.setFilterAddress(null);
      this.codeFace = encodeURI(code);
      this.valid = (code !== null && code !== '');
      this.recherchePanneauxLc();
    },
    setSlider(afficherSlider) {
      this.$emit('afficherSlider', afficherSlider);
    },
    recherchePanneauxLc() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      // if (!this.address) this.address = CENTER_RESEAUX_DEFAULT;
      // if (!this.rayon) this.rayon = 20000;
      this.actionsGestionPanneauxLc({ address: this.address,
        codeFace: this.codeFace,
        rayon: this.rayon,
        valid: this.valid,
        panneauxLcPanier: this.panneauxLcPanier,
      }).then(() => {
        loadingComponent.close();
      }).catch((e) => {
        loadingComponent.close();
        gestionErreur('Erreur lors de la recherche d\'un panneaux LC liée à l\'autocomplete', e);
      });
    },
  },
  mounted() {
    // this.setPlace({});
  },
};
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteFacesLc/filtres/autocomplete.vue